import React, { useRef, useState } from 'react';
import { Div, Img } from 'react-images/lib/primitives';
import { className } from 'react-images/lib/utils';
import { getSource } from 'react-images/lib/components/component-helpers';

function svgPlaceholder(width, height) {
  return `data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}"%3E%3C/svg%3E`;
}

export default function View({ enableZoom = true, ...props }) {
  const [scale, setScale] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);

  const start = useRef({ x: 0, y: 0 });
  const { data, formatters, getStyles, index, currentIndex, isFullscreen, isModal } = props;
  const overscan = 0;
  const inBounds = Math.abs(currentIndex - index) <= overscan;

  const handleWheel = e => {
    if (!enableZoom) {
      return;
    }
    e.preventDefault();

    const zoomSpeed = 0.1;
    let newScale = scale + (e.deltaY < 0 ? zoomSpeed : -zoomSpeed);

    newScale = Math.min(Math.max(1, newScale), 5);

    setScale(newScale);

    if (newScale === 1) {
      setPosition({ x: 0, y: 0 });
    }
  };

  const handleMouseDown = e => {
    if (!enableZoom) {
      return;
    }

    setDragging(true);
    start.current = {
      x: e.clientX - position.x,
      y: e.clientY - position.y
    };
  };

  const handleMouseMove = e => {
    if (!dragging) return;

    setPosition({
      x: e.clientX - start.current.x,
      y: e.clientY - start.current.y
    });
  };

  const handleMouseUp = () => {
    setDragging(false);
  };

  const handleReset = () => {
    setDragging(false);
    setPosition({ x: 0, y: 0 });
    setScale(1);
  };

  const getImageSource = () => {
    return getSource({ data, isFullscreen });
  };

  const innerProps = {
    alt: formatters.getAltText({ data, index }),
    src: inBounds ? getImageSource() : svgPlaceholder(data.width, data.height)
  };

  const cursor = enableZoom ? (dragging ? 'grabbing' : 'grab') : 'default';

  return (
    <Div
      css={getStyles('view', props)}
      className={className('view', { isFullscreen, isModal })}
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      <div
        style={{
          overflow: 'hidden',
          cursor,
          border: '1px solid #ddd',
          position: 'relative'
        }}
        onWheel={handleWheel}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
        onMouseDown={handleMouseDown}
        onDoubleClick={handleReset}
      >
        <Img
          {...innerProps}
          className={className('view-image', { isFullscreen, isModal })}
          css={{
            height: 'auto',
            maxHeight: '100vh',
            maxWidth: '100vw',
            userSelect: 'none'
          }}
          style={{
            transform: `translate(${position.x}px, ${position.y}px) scale(${scale})`,
            transformOrigin: 'center',
            userSelect: 'none',
            pointerEvents: 'none'
          }}
        />
      </div>
    </Div>
  );
}
